import React, { PureComponent } from "react";
import "@ant-design/compatible/assets/index.css";

import $ from "jquery";

import Config from "../Config";
import { connect } from "react-redux";
import { setConfig, ajaxHandler, ajaxViewHandler } from "../store/actions"; // "../../store/actions";

import "antd/dist/antd.css";

import DashboardPusatData from "../pages/DashboardPusatData";
import DaftarPkka from "../pages/eservice/pkka/DaftarPkka";
import DaftarPkkn from "../pages/eservice/pkkn/DaftarPkkn";
import DaftarRPK from "../pages/eservice/rpk/DaftarRpk";
import DaftarKantor from "../pages/eservice/kantor_cabang/DaftarKantor";
import DaftarSiupalSiopsus from "../pages/elicencing/siupal_siopsus/DaftarSiupalSiopsus";
import DaftarSiupkk from "../pages/elicencing/siupkk/DaftarSiupkk";

class MenuLayout extends PureComponent {
  config;
  timeoutGetQr;
  timeOutPushQr;

  constructor(props) {
    super(props);
    this.config = new Config();
    this.state = {
      msg: "",
      loading: false,
      loadingRedirect: false,
      logo: this.config.get_site_info().logo,

      counter: 0,
    };
  }

  componentDidUpdate(prevProps) { }

  componentDidMount() {

    var that = this;
    $(".navigation-main").hover(function () {
      if ($(".menu-popout").is(":visible")) {

        $(".pagesiupalsiopsus").click(function () {
          const className =
            this.className.split(" ")[1] != undefined
              ? this.className.split(" ")[1]
              : "";
          // console.log("className", className)
          if (className != "") {
            that.tabProses({
              title: "SIUPAL / SIOPSUS",
              key: "pagesiupalsiopsus",
              content: <DaftarSiupalSiopsus />,
            });
          }
        });

        $(".pagesiupkk").click(function () {
          const className =
            this.className.split(" ")[1] != undefined
              ? this.className.split(" ")[1]
              : "";
          // console.log("className", className)
          if (className != "") {
            that.tabProses({
              title: "SIUPKK",
              key: "pagesiupkk",
              content: <DaftarSiupkk />,
            });
          }
        });

        $(".pagerpk").click(function () {
          const className =
            this.className.split(" ")[1] != undefined
              ? this.className.split(" ")[1]
              : "";
          // console.log("className", className)
          if (className != "") {
            that.tabProses({
              title: "RPK",
              key: "pagerpk",
              content: <DaftarRPK />,
            });
          }
        });

        $(".pagepkka").click(function () {
          const className =
            this.className.split(" ")[1] != undefined
              ? this.className.split(" ")[1]
              : "";
          // console.log("className", className)
          if (className != "") {
            that.tabProses({
              title: "PKKA",
              key: "pagepkka",
              content: <DaftarPkka />,
            });
          }
        });


        $(".pagepkkn").click(function () {
          const className =
            this.className.split(" ")[1] != undefined
              ? this.className.split(" ")[1]
              : "";
          // console.log("className", className)
          if (className != "") {
            that.tabProses({
              title: "PPKN / DEVIASI LN",
              key: "pagepkkn",
              content: <DaftarPkkn />,
            });
          }
        });


        $(".pagekacab").click(function () {
          const className =
            this.className.split(" ")[1] != undefined
              ? this.className.split(" ")[1]
              : "";
          // console.log("className", className)
          if (className != "") {
            that.tabProses({
              title: "KANTOR CABANG",
              key: "pagekacab",
              content: <DaftarKantor />,
            });
          }
        });


      }
    });

    if (window.innerWidth <= 750) {
      $(".pagesiupalsiopsus").click(function () {
        const className =
          this.className.split(" ")[1] != undefined
            ? this.className.split(" ")[1]
            : "";
        // console.log("className", className)
        if (className != "") {
          that.tabProses({
            title: "SIUPAL / SIOPSUS",
            key: "pagesiupalsiopsus",
            content: <DaftarSiupalSiopsus />,
          });
        }
      });

      $(".pagesiupkk").click(function () {
        const className =
          this.className.split(" ")[1] != undefined
            ? this.className.split(" ")[1]
            : "";
        // console.log("className", className)
        if (className != "") {
          that.tabProses({
            title: "SIUPKK",
            key: "pagesiupkk",
            content: <DaftarSiupkk />,
          });
        }
      });

      $(".pagerpk").click(function () {
        const className =
          this.className.split(" ")[1] != undefined
            ? this.className.split(" ")[1]
            : "";
        // console.log("className", className)
        if (className != "") {
          that.tabProses({
            title: "RPK",
            key: "pagerpk",
            content: <DaftarRPK />,
          });
        }
      });

      $(".pagepkka").click(function () {
        const className =
          this.className.split(" ")[1] != undefined
            ? this.className.split(" ")[1]
            : "";
        // console.log("className", className)
        if (className != "") {
          that.tabProses({
            title: "PKKA",
            key: "pagepkka",
            content: <DaftarPkka />,
          });
        }
      });


      $(".pagepkkn").click(function () {
        const className =
          this.className.split(" ")[1] != undefined
            ? this.className.split(" ")[1]
            : "";
        // console.log("className", className)
        if (className != "") {
          that.tabProses({
            title: "PPKN / DEVIASI LN",
            key: "pagepkkn",
            content: <DaftarPkkn />,
          });
        }
      });


      $(".pagekacab").click(function () {
        const className =
          this.className.split(" ")[1] != undefined
            ? this.className.split(" ")[1]
            : "";
        // console.log("className", className)
        if (className != "") {
          that.tabProses({
            title: "KANTOR CABANG",
            key: "pagekacab",
            content: <DaftarKantor />,
          });
        }
      });


      $(".menu-item").on("click", function (ev) {
        $("body").removeClass("menu-open").addClass("menu-hide");
        $(".sidenav-overlay").removeClass("d-block").addClass("d-none");
        $(".menu-toggle").removeClass("is-active");
      });
      
    }
  }


  pilihMenu = (menu) => {
    if (menu == "beranda") {
      this.tabProses({
        title: "HOME",
        key: "beranda",
        content: <DashboardPusatData />,
      });
    }
    // else if (menu == "perizinan") {
    //   this.tabProses({
    //     title: "Perizinan",
    //     key: "perizinan",
    //     content: <Perizinan />,
    //   });
    // } else if (menu == "history") {
    //   this.tabProses({
    //     title: "History",
    //     key: "history",
    //     content: <History />,
    //   });
    // } else if (menu == "teamperformance") {
    //   this.tabProses({
    //     title: "Team Performance",
    //     key: "teamperformance",
    //     content: <TeamPerformance />,
    //   });
    // } else if (menu == "arsipproduk") {
    //   this.tabProses({
    //     title: "Arsip Produk",
    //     key: "arsipproduk",
    //     content: <ArsipProduk />,
    //   });
    // }
  };

  tabProses(tabData) {
    const key = tabData.key;
    var tempTabs = this.props.tabs;
    var isExist = false;
    tempTabs.map((item) => {
      if (item.key == key) {
        isExist = true;
      }
    });
    if (isExist) {
      this.props.setConfig({
        activeKey: tabData.key,
      });
    } else {
      tempTabs = [
        ...tempTabs,
        {
          title: tabData.title,
          content: tabData.content,
          key: tabData.key,
        },
      ];
      this.props.setConfig({
        tabs: tempTabs,
        activeKey: tabData.key,
      });
    }
  }


  render() {

    return (
      <div
        className="main-menu menu-fixed menu-light menu-accordion menu-shadow"
        data-scroll-to-active="true"
      >
        <div className="main-menu-content">
          <ul
            className="navigation navigation-main"
            id="main-menu-navigation"
            data-menu="menu-navigation"
          >
            <li className=" nav-item beranda">
              <a
                href="javascript:void(0);"
                onClick={() => this.pilihMenu("beranda")}
              >
                <i className="mbri-desktop"></i>
                <span className="menu-title">HOME</span>
              </a>
            </li>
            <li className=" nav-item has-sub">
              <a
                href="javascript:;"
              // onClick={() => this.pilihMenu("perizinan")}
              >
                <i className="mbri-sites"></i>
                <span className="menu-title">E-LICENCING</span>
                {/* <Badge count={this.state.counter} /> */}
              </a>
              <ul className="menu-content">
                <li>
                  <a
                    className=" nav-item pagesiupalsiopsus"
                    href="javascript:void(0);"
                  >
                    <i className="la la-square-o"></i>
                    <span>SIUPAL / SIOPSUS</span>
                  </a>
                </li>
                <li>
                  <a className=" nav-item pagesiupkk" href="javascript:;">
                    <i className="la la-square-o"></i>
                    <span>SIUPKK</span>
                  </a>
                </li>


              </ul >
            </li>
            <li className=" nav-item arsip-produk">
              <a
                href="javascript:void(0);"
              // onClick={() => this.pilihMenu("arsipproduk")}
              >
                <i className="mbri-sites"></i>
                <span className="menu-title">E-SERVICE</span>
              </a>
              <ul className="menu-content">
                <li>
                  <a
                    className=" nav-item pagerpk"
                    href="javascript:void(0);"
                  >
                    <i className="la la-square-o"></i>
                    <span>RPK</span>
                  </a>
                </li>
                <li>
                  <a
                    className=" nav-item pagepkka"
                    href="javascript:void(0);"
                  >
                    <i className="la la-square-o"></i>
                    <span>PKKA</span>
                  </a>
                </li>
                <li>
                  <a
                    className=" nav-item pagepkkn"
                    href="javascript:void(0);"
                  >
                    <i className="la la-square-o"></i>
                    <span>PPKN / DEVIASI LN</span>
                  </a>
                </li>
                <li>
                  <a
                    className=" nav-item pagekacab"
                    href="javascript:void(0);"
                  >
                    <i className="la la-square-o"></i>
                    <span>KANTOR CABANG</span>
                  </a>
                </li>
              </ul >
            </li>

          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  setConfig,
  ajaxHandler,
  ajaxViewHandler,
})(MenuLayout);
